/**
 * Адрес публичного сайта.
 *
 * Страницы акций и главная платформы живут на Go-сервере, приложение — отдельно.
 * В разработке это localhost:8080, в бою задаётся при сборке.
 */
export const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'http://localhost:8080';

/**
 * Соцсети платформы.
 *
 * Одно место на всё приложение. Адреса переопределяются при сборке: у
 * пилота имена могут поменяться, и искать их потом по шаблонам — плохая
 * сделка. Пустая строка убирает значок совсем: ссылка на несуществующий
 * аккаунт хуже, чем его отсутствие.
 */
/**
 * Адрес поддержки.
 *
 * Один на всё приложение: он же стоит в подвале сайта и в правилах акций, и
 * человеку незачем искать два разных способа с нами связаться.
 */
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL ?? 'info@allswipes.com';

interface Social {
  name: 'telegram' | 'instagram' | 'x' | 'tiktok' | 'linkedin' | 'mail';
  label: string;
  href: string;
}

export const SOCIALS: Social[] = ([

  {
    name: 'telegram',
    label: 'Телеграм',
    href: import.meta.env.VITE_TELEGRAM ?? 'https://t.me/meta4verse',
  },
  {
    name: 'instagram',
    label: 'Инстаграм',
    href: import.meta.env.VITE_INSTAGRAM ?? 'https://instagram.com/allswipes',
  },
  {
    name: 'x',
    label: 'X',
    href: import.meta.env.VITE_X ?? 'https://x.com/allswipes',
  },
  {
    name: 'tiktok',
    label: 'TikTok',
    href: import.meta.env.VITE_TIKTOK ?? 'https://tiktok.com/@allswipes',
  },
  {
    name: 'linkedin',
    label: 'LinkedIn',
    href: import.meta.env.VITE_LINKEDIN ?? 'https://linkedin.com/company/allswipes',
  },
  {
    name: 'mail',
    label: 'Почта',
    href: `mailto:${CONTACT_EMAIL}`,
  },
] as Social[]).filter((s) => s.href && s.href !== 'mailto:');

/**
 * Ссылка на серверную страницу с языком интерфейса.
 *
 * Страница акции, «О проекте» и юридические живут на Go-сервере, и язык он
 * выбирает по заголовку браузера. Человек, который переключил приложение на
 * английский, уходил по ссылке и получал русскую страницу: его выбор до
 * сервера просто не доезжал. Параметр доезжает.
 */
export function sitePage(path: string, lang: string): string {
  const [base, hash] = path.split('#');
  const sep = (base ?? '').includes('?') ? '&' : '?';
  return `${SITE_URL}${base}${sep}lang=${lang}${hash ? `#${hash}` : ''}`;
}
